<template>
  <el-dialog
    class="company-querylog-modal"
    width="90%"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <div v-loading="isLoading" class="statistic_page">
      <div class="tabs">
        <div class="tab-item" :class="currentView==='vin' ? 'current': ''" @click="currentView='vin'">
          <div class="name">VIN查询</div>
          <div class="count">{{ totalInfos.vin || '--' }}</div>
        </div>
        <div class="tab-item" :class="currentView==='oe' ? 'current': ''" @click="currentView='oe'">
          <div class="name">OE查询</div>
          <div class="count">{{ totalInfos.oe || '--' }}</div>
        </div>
        <div class="tab-item" :class="currentView==='carModel' ? 'current': ''" @click="currentView='carModel'">
          <div class="name">车型查询</div>
          <div class="count">{{ totalInfos.carModel || '--' }}</div>
        </div>
        <div class="tab-item" :class="currentView==='stock' ? 'current': ''" @click="currentView='stock'">
          <div class="name">大库查询</div>
          <div class="count">{{ totalInfos.stock || '--' }}</div>
        </div>
      </div>
      <div class="statistic-view">
        <keep-alive>
          <component :is="VinQueryLog" v-if="currentView==='vin'" :company-id="companyId" />
          <component :is="CarModelQueryLog" v-if="currentView==='carModel'" :company-id="companyId" />
          <component :is="OeQueryLog" v-if="currentView==='oe'" :company-id="companyId" />
          <component :is="StockQueryLog" v-if="currentView==='stock'" :company-id="companyId" />
        </keep-alive>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import CarModelQueryLog from './CarModelQueryLog.vue'
import StockQueryLog from './StockQueryLog.vue'
import OeQueryLog from './OeQueryLog.vue'
import VinQueryLog from './VinQueryLog.vue'
import { ListQueryTotal } from '../services'
import ModalMixin from '@/mixins/modal/modal-mixin'
export default {
  name: 'QueryLogModal',
  mixins: [ModalMixin],
  data () {
    return {
      isLoading: false,
      companyId: 0,
      totalInfos: {
        vin: 0,
        oe: 0,
        carModel: 0,
        stock: 0
      },
      currentView: 'vin',
      CarModelQueryLog,
      StockQueryLog,
      OeQueryLog,
      VinQueryLog
    }
  },
  methods: {
    init (companyId) {
      this.companyId = companyId
      this.fetchData()
      return this.open()
    },
    fetchData () {
      this.isLoading = true
      ListQueryTotal({ companyId: this.companyId }).then((res) => {
        this.totalInfos = res
        this.isLoading = false
      })
    }
  }
}
</script>
<style lang="stylus">
.company-querylog-modal
  .el-dialog
    max-width 1024px
    .el-dialog__header
      padding: 0
    .el-dialog__headerbtn
      top: 10px
      right: 10px
    .statistic_page
      height 510px
      display flex
      flex-direction column
      .tabs
        width 100%
        display flex
        flex-direction row
        >.tab-item
          flex 1
          border 1px solid #e4e4e4
          padding 10px
          text-align center
          position relative
          +.tab-item
            margin-left 10px
          .count
            line-height: 40px
            color: #000
            font-weight: 600
            font-size: 28px
          &.current
            background-color: #e4e4e4
            &:after
              content: ' '
              position: absolute
              width: 0px
              height: 0px
              border-width: 8px
              border: 8px solid transparent
              border-top: 8px solid #e4e4e4
              left: 0
              right: 0
              margin: auto
              bottom: -16px
      .statistic-view
        margin-top 4px
        height: 400px
        position: relative
        padding-top 38px
        .chart-type-switcher
          right: 0px
          position: absolute
          top: 6px
        .base-data-table
          height 370px
          border-bottom 1px solid #d4d4d4
          td
            padding 2px 6px
          .no-data
            text-align center
            line-height 8
            color #9d9d9d
        .el-pagination
          margin-top 4px
          padding 2px 0
        .line-chart-container
          position relative
          height 400px
          .chart-area
            position relative
            display flex
            flex-direction column
            height 100%
            .time-select
              position absolute
              left 0
              top -36px
</style>
